import { IntlNumberCurrencyOptions } from '../types/'

export function convertPriceToCurrency(
  language: string,
  options: IntlNumberCurrencyOptions,
  amount: number,
) {
  return new Intl.NumberFormat(language, options).format(amount)
}

function enforceTwoDecimalPlaces(
  value: string,
  decimalSeparator: string,
): string {
  const stringAsTuple: string[] = value.split(decimalSeparator)
  return (
    stringAsTuple[0] +
    decimalSeparator +
    (stringAsTuple[1].length === 2 ? stringAsTuple[1] : stringAsTuple[1] + '0')
  )
}

export function convertCentsToUSD(amountInCents: number): string {
  const valueWithShiftedDecimal = amountInCents / 100
  if (valueWithShiftedDecimal === Math.floor(valueWithShiftedDecimal)) {
    return valueWithShiftedDecimal.toString()
  }
  return enforceTwoDecimalPlaces(
    convertPriceToCurrency(
      'en-us',
      { type: 'currency', currency: 'USD' },
      amountInCents / 100,
    ),
    '.',
  )
}
